// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-53457bab]{color:#000}.info-about-doctor[data-v-53457bab]{width:100%}.info-about-doctor .avatar-wrapper[data-v-53457bab]{position:relative;border-radius:50%;overflow:hidden;-webkit-box-shadow:0 7px 15px rgba(0,0,0,.06);box-shadow:0 7px 15px rgba(0,0,0,.06)}.info-about-doctor .name[data-v-53457bab]{font-size:22px}@media (max-width:578px){.info-about-doctor .name[data-v-53457bab]{font-size:20px}}", ""]);
// Exports
module.exports = exports;
